import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Column, Cell } from 'fixed-data-table-2';
import 'fixed-data-table-2/dist/fixed-data-table.css';


import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';


import * as CustomerContacts from './Saga/CustomerContacts';

import Tooltip from '@mui/material/Tooltip';

import MenuItem from '@mui/material/MenuItem';import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import Select from '@mui/material/Select';import EditIcon from '@mui/icons-material/Edit';


import MaskedInput from 'react-text-mask';
var moment = require('moment-timezone');


const phoneNumberMask = [
  "(",
  /[0-9]/,
  /\d/,
  /\d/,
  ")",
  " ",
  /\d/,
  /\d/,
  /\d/,
  "-",
  /\d/,
  /\d/,
  /\d/,
  /\d/
];


const mobileNumberMask = [
  "(",
  /[0-9]/,
  /\d/,
  /\d/,
  ")",
  " ",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  "-",
  /\d/,
  /\d/,
  /\d/,
  /\d/
];
function TelMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (

    <MaskedInput
      {...other}
      // ref={inputRef}
      mask={String(props.value).replace("(", "").replace(")", "").replace("-", "").slice(0, 3) === "090" || String(props.value).replace("(", "").replace(")", "").replace("-", "").slice(0, 3) === "080" || String(props.value).replace("(", "").replace(")", "").replace("-", "").slice(0, 3) === "070" || String(props.value).replace("(", "").replace(")", "").replace("-", "").slice(0, 3) === "050" ? mobileNumberMask : phoneNumberMask}
      placeholderChar={'\u2000'}
    // showMask
    />
  );
}

const Base = ({ column, props, rowIndex }) =>
  <Cell style={{ whiteSpace: "nowrap" }} >
    {props.rent_visits[rowIndex][column.key]}
  </Cell>;

const Sex = ({ column, props, rowIndex }) =>
  <Cell style={{ whiteSpace: "nowrap" }} >
    {props.rent_contract_family_editor_disp ? <Select
      labelId="demo-simple-select-outlined-label"
      id="demo-simple-select-outlined"
      style={{ width: 30 }}
      name="sex"
      value={props.rent_contract_editor_forms.family[rowIndex][column.key] ? props.rent_contract_editor_forms.family[rowIndex][column.key] : 1}
    // value={props.rent_contract_editor_forms.family[rowIndex][column.key]}
    // defaultValue={this.props.rent_contract_editor_forms.room_id ? { value: this.props.rent_contract_editor_forms.room_id, label: this.props.rent_contract_editor_forms.room_name } : {}}
    // value={this.props.rent_contract_editor_forms.room_id}
    // onChange={this.handleChange}
    // label="部屋名"
    >
      <MenuItem value={1}>
        男
      </MenuItem>
      <MenuItem value={2}>
        女
      </MenuItem>
    </Select> : props.rent_contract_editor_forms.family[rowIndex][column.key] === 1 ? "男" : "女"}
  </Cell>;

const Birthday = ({ column, props, rowIndex }) =>
  <Cell style={{ whiteSpace: "nowrap" }} >
    {props.rent_contract_family_editor_disp ? <TextField
      id="date"
      // label="生年月日"
      type="date"
      name="birthday"
      style={{ width: 130 }}
      // onChange={this.handleChange}
      value={props.rent_contract_editor_forms.family[rowIndex][column.key]}
      // className={classes.textField}
      InputLabelProps={{
        shrink: true,
      }}
    /> :
      props.rent_contract_editor_forms.family[rowIndex][column.key] ? <div style={{ lineHeight: 1 }}> <div>{moment(props.rent_contract_editor_forms.family[rowIndex][column.key]).format("YYYY年M月D日")}</div>  <div>{"(" + age(props.rent_contract_editor_forms.family[rowIndex][column.key]) + "歳)"}</div> </div> : ""}
  </Cell >


function age(birthDate) {
  birthDate = new Date(birthDate);
  // 文字列に分解
  const y2 = birthDate.getFullYear().toString().padStart(4, '0');
  const m2 = (birthDate.getMonth() + 1).toString().padStart(2, '0');
  const d2 = birthDate.getDate().toString().padStart(2, '0');

  // 今日の日付
  const today = new Date();
  const y1 = today.getFullYear().toString().padStart(4, '0');
  const m1 = (today.getMonth() + 1).toString().padStart(2, '0');
  const d1 = today.getDate().toString().padStart(2, '0');

  // 引き算
  const age = Math.floor((Number(y1 + m1 + d1) - Number(y2 + m2 + d2)) / 10000);
  return age;

}

const Name = ({ column, props, rowIndex, family }) =>
  <Cell style={{ whiteSpace: "nowrap" }} >
    {props.rent_contract_family_editor_disp ? <TextField
      id="outlined-basic"
      //   className={classes.textField}
      label=""
      margin="normal"
      name="name"
      // onChange={this.handleChange}
      inputProps={{ min: 0, style: { textAlign: 'left' } }} // the change is here
      // value={monies[rowIndex][column.key]}
      style={{ width: "80px", marginTop: 0 }}

    /> : props.rent_contract_editor_forms.family[rowIndex].name}

  </Cell>;


const Workplace = ({ column, props, rowIndex, family }) =>
  <Cell style={{ whiteSpace: "nowrap" }} >
    {props.rent_contract_family_editor_disp ? <TextField
      id="outlined-basic"
      //   className={classes.textField}
      label=""
      margin="normal"
      name="workplace"
      // onChange={this.handleChange}
      inputProps={{ min: 0, style: { textAlign: 'left' } }} // the change is here
      // value={monies[rowIndex][column.key]}
      style={{ width: "80px", marginTop: 0 }}

    /> : props.rent_contract_editor_forms.family[rowIndex].workplace}

  </Cell>;

const Tel = ({ column, props, rowIndex, family }) =>
  <Cell style={{ whiteSpace: "nowrap" }} >
    {props.rent_contract_family_editor_disp ?
      <TextField
        // variant="outlined"
        name="tel"
        // label="電話番号1"
        type="tel"
        value={props.rent_contract_editor_forms.family[rowIndex].tel}
        // onChange={this.handleChange}
        id="formatted-numberformat-input"
        style={{ float: "left", width: "100%", paddingRight: "5px" }}

        InputProps={{
          inputComponent: TelMaskCustom,
        }}
      // InputLabelProps={{
      //   shrink: true,
      // }}
      />


      //   <TextField
      //   id="outlined-basic"
      //   //   className={classes.textField}
      //   label=""
      //   margin="normal"
      //   name="tel"
      //   // onChange={this.handleChange}
      //   inputProps={{ min: 0, style: { textAlign: 'left' } }} // the change is here
      //   // value={monies[rowIndex][column.key]}
      //   style={{ width: "80px", marginTop: 0 }}

      // />
      : props.rent_contract_editor_forms.family[rowIndex].tel}

  </Cell>;

const Nationality = ({ column, props, rowIndex, family }) =>
  <Cell style={{ whiteSpace: "nowrap" }} >
    {props.rent_contract_family_editor_disp ? <TextField
      id="outlined-basic"
      //   className={classes.textField}
      label=""
      margin="normal"
      name="nationality"
      // onChange={this.handleChange}
      inputProps={{ min: 0, style: { textAlign: 'left' } }} // the change is here
      // value={monies[rowIndex][column.key]}
      style={{ width: "80px", marginTop: 0 }}

    /> : props.rent_contract_editor_forms.family[rowIndex].nationality}

  </Cell>;

const Remarks = ({ column, props, rowIndex, family }) =>
  <Cell style={{ whiteSpace: "nowrap" }} >
    {props.rent_contract_family_editor_disp ? <TextField
      id="outlined-basic"
      //   className={classes.textField}
      label=""
      margin="normal"
      name="remarks"
      // onChange={this.handleChange}
      inputProps={{ min: 0, style: { textAlign: 'left' } }} // the change is here
      // value={monies[rowIndex][column.key]}
      style={{ width: "80px", marginTop: 0 }}

    /> : props.rent_contract_editor_forms.family[rowIndex].remarks}

  </Cell>;

const Relations = ({ column, props, rowIndex, family }) =>
  <Cell style={{ whiteSpace: "nowrap" }} >
    {props.rent_contract_family_editor_disp ? <span><input type="text" list="data" style={{ width: 60 }} />

      <datalist id="data">

        <option key={1} value="本人" />
        <option key={2} value="婚約者" />
        <option key={3} value="父" />
        <option key={4} value="母" />
        <option key={5} value="兄" />
        <option key={6} value="姉" />
        <option key={7} value="弟" />
        <option key={8} value="妹" />
        <option key={9} value="祖父" />
        <option key={10} value="祖母" />
        <option key={11} value="妻" />
        <option key={12} value="夫" />
        <option key={13} value="子" />
        <option key={14} value="社員" />
      </datalist> </span> : props.rent_contract_editor_forms.family[rowIndex].name}

  </Cell>;




const Delete = ({ column, props, rowIndex, monies }) =>
  <Cell style={{ whiteSpace: "nowrap" }} >
    <Tooltip title="削除" >
      <IconButton size="small" aria-label="delete" onClick={() => this.props.change_rent_contract_editor_disp(false)}>
        <DeleteForeverIcon color="secondary" />
      </IconButton>
    </Tooltip>
  </Cell>;



const Edit = ({ column, props, rowIndex, monies }) =>
  <Cell style={{ whiteSpace: "nowrap" }} >
    <Tooltip title="編集" >
      <IconButton size="small" aria-label="edit" onClick={() => props.set_visit_edit({ id: props.rent_visits[rowIndex].rent_customer_contact_id, disp: true, rent_visit_id: props.rent_visits[rowIndex].id, tatemono_name: props.rent_visits[rowIndex].tatemono_name, tatemono_id: props.rent_visits[rowIndex].tatemono_id, remarks: props.rent_visits[rowIndex].remarks, date: props.rent_visits[rowIndex].date, user_id: props.rent_visits[rowIndex].user_id, room_id: props.rent_visits[rowIndex].room_id, room_name: props.rent_visits[rowIndex].room_name, no: props.rent_visits[rowIndex].no })}>
        <EditIcon />
      </IconButton>
    </Tooltip>
  </Cell>;




var SortTypes = {
  ASC: 'ASC',
  DESC: 'DESC',
};


function reverseSortDirection(sortDir) {
  return sortDir === SortTypes.DESC ? SortTypes.ASC : SortTypes.DESC;
}
class SortHeaderCell extends React.Component {
  constructor(props) {
    super(props);

    this._onSortChange = this._onSortChange.bind(this);
  }

  render() {
    var { onSortChange, sortDir, children, ...props } = this.props;
    return (
      <Cell {...props} onClick={this._onSortChange}>

        {children} {sortDir ? (sortDir === SortTypes.DESC ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />) : ''}

      </Cell>
    );
  }

  _onSortChange(e) {

    e.preventDefault();

    if (this.props.onSortChange) {
      this.props.onSortChange(
        this.props.columnKey,
        this.props.sortDir ?
          reverseSortDirection(this.props.sortDir) :
          SortTypes.DESC
      );
    }
  }
}


const columns = [
  { key: 'edit', name: '編集', width: 60 },
  { key: 'tatemono_name', name: '物件名', width: 100 },
  { key: 'room_name', name: '部屋名', width: 70 },
  {
    key: 'remarks', name: '備考', width: 150,

  },


]







class VisitList extends Component {
  constructor(props) {
    super(props);


    // this.props.rent_m_contract_follows_disp.map(async function (value) {
    //   if (value.disp) {
    //     columns.push({ key: value.key_name, name: value.name, company: value.company, width: 80 })
    //   }
    // })
    console.log(columns)

    this.state = {
      columns: columns,
      reflesh: false,
      modalreserve: false,
      cardx: window.innerWidth - 600,
      colSortDirs: {},

      // dataList: new FakeObjectDataListStore(1000000),
      // columnWidths: {
      //   firstName: 240,
      //   lastName: 150,
      //   sentence: 140,
      //   companyName: 60,
      // },
    };
    // this.props.get_contract_follow_list()
    this._onColumnResizeEndCallback = this._onColumnResizeEndCallback.bind(this);



    this.add_new = this.add_new.bind(this);


  }





  _onColumnResizeEndCallback(newColumnWidth, columnKey) {

    let columnsset = this.state.columns.map(function (value) {
      if (value.key === columnKey) {
        value.width = newColumnWidth
      }
      return value
    })

    this.setState({ columns: columnsset })

  }



  add_new() {
    let rent_contract_editor_forms = this.props.rent_contract_editor_forms
    // let family = rent_contract_editor_forms.family.map(function (value) {
    //   return value
    // })

    rent_contract_editor_forms.family.push({
      name: "",
      relations: "",
      sex: 0,
      birthday: null,
      workplace: '',
      tel: '',
      nationality: '',
      remarks: '',
    })
    // rent_contract_editor_forms.family = family
    this.props.change_rent_contract_editor_forms(rent_contract_editor_forms)

    this.setState({ reflash: !this.state.reflash })
  }








  render() {
    let hiwari = []

    return (
      <div id="contract_car" >



        {<div style={{ marginTop: 10, marginBottom: 10 }}><Table
          rowHeight={40}
          rowsCount={this.props.rent_visits.length}
          onColumnResizeEndCallback={this._onColumnResizeEndCallback}
          isColumnResizing={false}
          touchScrollEnabled={true}
          width={340}
          height={this.props.rent_visits.length * 40 + 60}
          // width={window.innerWidth - 110}
          // height={window.innerHeight - 250}
          headerHeight={40}>
          {this.state.columns.map(function (value, i) {
            return <Column
              columnKey={value.key}
              header={<SortHeaderCell
                onSortChange={this._onSortChange}
                sortDir={this.state.colSortDirs[value.key]}
                style={{ whiteSpace: "nowrap" }}>{value.name}</SortHeaderCell>}

              // cell={({ rowIndex, ...props }) => (<Cell style={{ whiteSpace: "nowrap" }} >{this.props.seisan_follow_list[rowIndex][value.key]}</Cell>)}
              cell={({ rowIndex, ...props }) => (

                value.key === "sex" ? <Sex column={value} props={this.props} rowIndex={rowIndex} family={this.state.family}></Sex>
                  : value.key === "birthday" ? <Birthday column={value} props={this.props} rowIndex={rowIndex} family={this.state.family}></Birthday>
                    : value.key === "relations" ? <Relations column={value} props={this.props} rowIndex={rowIndex} ></Relations>

                      : value.key === "name" ? <Name column={value} props={this.props} rowIndex={rowIndex} ></Name>
                        : value.key === "delete" ? <Delete column={value} props={this.props} rowIndex={rowIndex} monies={hiwari}></Delete>

                          : value.key === "workplace" ? <Workplace column={value} props={this.props} rowIndex={rowIndex} monies={hiwari}></Workplace>
                            : value.key === "tel" ? <Tel column={value} props={this.props} rowIndex={rowIndex} monies={hiwari}></Tel>
                              : value.key === "nationality" ? <Nationality column={value} props={this.props} rowIndex={rowIndex} monies={hiwari}></Nationality>
                                : value.key === "edit" ? <Edit column={value} props={this.props} rowIndex={rowIndex} ></Edit>


                                  // :
                                  : <Base column={value} props={this.props} rowIndex={rowIndex} ></Base>

              )}

              width={value.width}
              isResizable={true}


            />
          }, this)}

        </Table > </div>
        }




      </div >
    );
  }
};


//export  default CustomerList;
const mapStateToProps = (state) => {
  return {
    section_select: state.masterReducer.section_select,
    // search_modal: state.Adjustment.search_modal,
    user_details: state.masterReducer.user_details,
    users_select: state.masterReducer.users_select,
    rent_contract_details: state.contracts.rent_contract_details,
    rent_contract_family_editor_disp: state.contracts.rent_contract_family_editor_disp,
    rent_contract_editor_forms: state.contracts.rent_contract_editor_forms,
    // rent_visits: state.customerContactsReducer.rent_visits,
  }
}
function mapDispatchToProps(dispatch) {
  return {


    get_rent_visits(state) {
      dispatch(CustomerContacts.get_rent_visits(state))
    },

    set_visit_edit(state) {
      dispatch(CustomerContacts.set_visit_edit(state))
    },
    // change_rent_contract_editor_forms(state) {
    //   dispatch(Contracts.change_rent_contract_editor_forms(state))
    // },
    // check_rent_contract_editor_disp(state) {
    //   dispatch(Contracts.check_rent_contract_editor_disp(state))
    // },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(VisitList);